// extracted by mini-css-extract-plugin
export default {"Wrapper":"AgencyImage_Wrapper__cc95A","LogoImage":"AgencyImage_LogoImage__G3v2m"};